<template>
	<div class="page-header">
		<div class="wrapper">
			<div class="page-header__cont">
				<a class="back-link" v-if="backLink" :href="backLink">Вернуться назад</a>

				<slot name="back-action-link"></slot>

				<h1 class="page-title">{{pageTitle}}</h1>
				<slot name="btns"></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "PageTitle",
	props: {
		pageTitle: {
			type: String,
			default: '',
		},
		backLink: {
			type: String,
			default: ''
		},
	}
}
</script>

